import React from 'react';
import AddInsuranceModalInsuranceFooter from './AddInsuranceModalInsuranceFooter';
import AddInsuranceModalCoverageFooter from './AddInsuranceModalCoverageFooter';
import { InsurancePolicyModalProps } from '../../hooks/useInsurancePolicyModal';
import useAddInsuranceModalContext from '../../hooks/useAddInsuranceModalContext';

interface Props {
  onClose: () => void;
  onSubmit: () => void;
  insuranceModalProps: InsurancePolicyModalProps;
}

const AddInsuranceModalFooter: React.FC<Props> = ({
  onSubmit,
  onClose,
  insuranceModalProps,
}) => {
  const { page, coverages } = insuranceModalProps;
  const { riskObjects } = useAddInsuranceModalContext();
  /** Every risk should at least have 1 coverage */
  const allRisksHaveCoverages = riskObjects.every(({ label }) =>
    coverages.some(({ risk_object }) => label === risk_object),
  );
  const isCoverageSubmitDisabled =
    !allRisksHaveCoverages && page.index === riskObjects.length - 1;

  if (page.type === 'INSURANCE') {
    return (
      <AddInsuranceModalInsuranceFooter
        onClose={onClose}
        isDisabled={!riskObjects.length}
        insuranceModalProps={insuranceModalProps}
      />
    );
  }
  return (
    <AddInsuranceModalCoverageFooter
      onSubmit={onSubmit}
      isDisabled={isCoverageSubmitDisabled}
      insuranceModalProps={insuranceModalProps}
    />
  );
};

export default AddInsuranceModalFooter;
